import { Banner, Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { getUserDisplayName } from 'utils/user';

import { CompareContactsTable } from '../compareContactsTable/compareContactsTable';

import styles from './previewContact.module.scss';

export type PreviewContactProps = {
  /** Target contact to merge values from source contact into */
  targetContact: User;
  /** Source user that is merged into target user */
  sourceContact: User;
  /** Preview contact that resembles the merged contact */
  previewContact: User;
};

export const PreviewContact = ({
  targetContact,
  sourceContact,
  previewContact,
}: PreviewContactProps): JSX.Element => {
  return (
    <FlexBox flexDirection="column" alignItems="center" gap="400">
      <Text.Paragraph>
        You&apos;re merging <strong>{getUserDisplayName(targetContact)}</strong>{' '}
        and <strong>{getUserDisplayName(sourceContact)}</strong> into a single
        contact, <strong>{getUserDisplayName(previewContact)}</strong>, and this
        is how your merged contact will look like.
      </Text.Paragraph>

      <Banner
        variant="warning"
        description={
          <Text.Paragraph>
            The merging action you are about to perform is permanent and
            irreversible!
          </Text.Paragraph>
        }
      />

      <Box width="100%" maxWidth="75%">
        <CompareContactsTable
          contacts={[previewContact]}
          previewContact={previewContact}
          className={styles.compareContactsTable}
        />
      </Box>
    </FlexBox>
  );
};
